import { createFileRoute } from '@tanstack/react-router';
import { BasicStepForm } from './-components/project-new-steps/basic-step';

export const Route = createFileRoute('/ngos/projects/new/basic')({
	component: BasicStepForm,
});
